import { render, staticRenderFns } from "./ValueOfGoodsHSCode.vue?vue&type=template&id=7e990c24"
import script from "./ValueOfGoodsHSCode.vue?vue&type=script&lang=js"
export * from "./ValueOfGoodsHSCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports